import axios from '../Api/api';

export default function starting() {
    return new Promise((resolve, reject) => {
        axios.get("/product/startingPage", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
